<template>
    <div>
        <el-table
                size="mini"
                border
                height="120"
                ref="xhTable"
                :data="tablexhData"
                tooltip-effect="dark"
                style="width: 100%;margin-bottom:10px">
            <!--row-key="vc_unique"-->
            <!--v-loading="loading"-->
            <!--<template slot="empty">
                <p>{{dataText}}</p>
            </template>-->
            <!--<el-table-column
                    align="left"
                    type="selection"
                    :reserve-selection="true"
                    width="55">
            </el-table-column>-->
            <el-table-column
                    align="left"
                    prop="i_id"
                    label="ID"
                    width="60"
            >
            </el-table-column>
            <!--<el-table-column
                    align="left"
                    prop="f_ccnum"
                    label="交付数量"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="left"
                    prop="f_xhnum"
                    label="消耗数量"
            >
            </el-table-column>-->
            <el-table-column
                    align="left"
                    prop="f_num"
                    label="核算数量"
                    show-overflow-tooltip>
                <!--<template slot-scope="scope">
                    <el-input-number :controls="false" :precision="3" class="" size="mini" v-model="scope.row.f_num" ></el-input-number>
                </template>-->
            </el-table-column>
            <el-table-column
                    align="left"
                    prop="f_jsdj"
                    label="加工单价">
                <template slot-scope="scope">
                    <el-input-number :controls="false" :precision="5" class="" size="mini" v-model="scope.row.f_jsdj" ></el-input-number>
                </template>
            </el-table-column>
            <el-table-column
                    sortable
                    prop="f_zj"
                    label="总价">
                <template slot-scope="scope">
                    {{ (scope.row.f_zj = scope.row.f_num *scope.row.f_jsdj) | keepTwoNum}}
                </template>
            </el-table-column>
        </el-table>
        <el-table
                size="mini"
                border
                :summary-method="getSummaries"
                show-summary
                height="390"
                ref="Table"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                v-loading="loading">
            <!--row-key="vc_unique"-->
            <template slot="empty">
                <p>{{dataText}}</p>
            </template>
            <!--<el-table-column
                    align="left"
                    type="selection"
                    :reserve-selection="true"
                    width="55">
            </el-table-column>-->
            <el-table-column
                    align="left"
                    prop="i_id"
                    label="ID"
                    width="60"
                    >
            </el-table-column>
            <el-table-column
                    align="left"
                    prop="vc_pzname"
                    :label="$t('form_product_name')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="left"
                    prop="vc_unit"
                    label="单位"
                    >
            </el-table-column>
            <el-table-column
                    align="left"
                    prop="f_num"
                    label="数量"
                    show-overflow-tooltip>
                <!--<template slot-scope="scope">
                    <el-input-number :controls="false" :precision="3" class="" size="mini" v-model="scope.row.f_num" ></el-input-number>
                </template>-->
            </el-table-column>
            <el-table-column
                    align="left"
                    prop="f_cbdj"
                    label="成本单价">
                <!--<template slot-scope="scope">
                    <el-input-number :controls="false" :precision="3" class="" size="mini" v-model="scope.row.f_cbdj" ></el-input-number>
                </template>-->
            </el-table-column>
            <el-table-column
                    align="left"
                    prop="f_jsdj"
                    label="结算单价">
                <template slot-scope="scope">
                    <!--<el-input-number :controls="false" :min="0" :precision="5" class="" size="mini" v-model="scope.row.f_jsdj" >-->
                        {{scope.row.f_num==0?0:(scope.row.f_jsdj = scope.row.f_zj /scope.row.f_num) | keepTwoNum }}
                    <!--</el-input-number>-->
                </template>
            </el-table-column>
            <el-table-column
                    sortable
                    prop="f_zj"
                    label="总价">
                <template slot-scope="scope">
                    <el-input-number :controls="false" :min="0" :precision="2" class="" size="mini" v-model="scope.row.f_zj" >
                        {{ (scope.row.f_zj = scope.row.f_num *scope.row.f_jsdj) | keepTwoNum}}
                    </el-input-number>
                </template>
            </el-table-column>
        </el-table>
        <div slot="footer" class="mrt20" style="text-align: center">
            <el-button type="primary" :class="baseerp+'btn'" size="small" :disabled="disabled" @click="saveStatisticsXh()">{{$t('button_save')}}</el-button>
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";

    export default {
        name: "CostList",
        components: {},
        props: {
            cost: {
                type: Object,
                required: true,
            }
        },
        filters: {
            keepTwoNum(value){
                value = Number(value);
                return value.toFixed(2)
            }
        },
        data() {
            return {
                mid:0,
                disabled:false,
                jsId:"",
                baseerp: "",
                //tableHeight:0,
                loading:true,
                tablexhData:[],
                tableData:[],
                dataText:this.$t('tips_data_loading_in_progress'),
            }
        },


        /*当数据没被销毁的情况下用监听，弹窗关闭后数据重加载 原数据已经没有 此时不需要用监听*/
        /*watch: {
            sheet: {
                handler() {
                    if (this.sheet) {
                        console.log(this.sheet,"从父级拿到");
                        this.Istate=this.sheet.i_state;
                       /!* //this.pageSize=this.page_size;
                        this.i_id = this.sheet.i_id;
                        this.mid = this.sheet.i_mid;
                        if (this.sheet.i_id == 0) {
                            this.getDateYYYYMMddHHMMSS();
                            this.title = this.sheet.title;
                            this.form = this.sheet.taskDa;
                            //this.formList=this.sheet.taskDa;
                            // console.log(this.sheet,this.title,this.form,"i_id",this.sheet.i_id)
                            this.sheetDetails = this.sheet.taskDa;
                            this.sheetDetails.i_mid = this.mid;
                            this.sheetDetails.selected=[];
                            this.edit = false;
                            this.chakan = false;
                            this.votevote = false;
                            this.commit = true;
                            this.formData = {
                                wtname: this.form.vc_outgsname,
                                gsname: this.form.vc_gsname,
                                bmname: this.form.vc_cjname,
                                num: "000000",
                                ckname: this.form.vc_ckname,
                                vc_pno: this.form.vc_pno,
                                vc_note: "",
                                vc_lruname: sessionStorage.getItem("lruname"),
                                date: this.date,
                                jftableData: [],
                                //xhtableData:[],
                                //sqname:sessionStorage.getItem("lruname"),
                            };
                        } else {
                            /!*if (this.feeding.title=="预览"){
                                this.chakan=true;
                            }else {
                                this.chakan=false;
                            }*!/
                            //编辑
                            this.votevote = true;
                            this.edit = true;
                            this.isbtn = true;
                            this.editForm = this.sheet.value;
                            this.getvoid=this.editForm.i_state==0?false:true;
                            this.form = this.sheet.taskDa;
                            this.title = this.sheet.title;
                            this.commit = this.editForm.i_state != 0 ? true : false;
                            // console.log(this.sheet,this.title,this.form,this.editForm,"i_id",this.sheet.i_id)
                            this.formData = {
                                wtname: this.form.vc_outgsname,
                                gsname: this.form.vc_gsname,
                                bmname: this.form.vc_cjname,
                                num: "000000",
                                ckname: this.form.vc_ckname,
                                vc_pno: this.form.vc_pno,
                                vc_note: this.editForm.vc_note,
                                vc_lruname: sessionStorage.getItem("lruname"),
                                date: this.editForm.dt_createtime,
                                jftableData: [],
                                // xhtableData:[],
                                // sqname:sessionStorage.getItem("lruname"),
                            };
                            //调点击编辑查看交付单时调用的接口
                            this.getOutputDetails();*!/
                        }
                    }
                },
                immediate: true,
                deep: true
            },*/


        mounted() {
            this.baseerp=baseerp;
            /*this.$nextTick(function () {
                this.tableHeight = window.innerHeight - this.$refs.Table.$el.clientTop - 280;

                // 监听窗口大小变化
                let self = this;
                window.onresize = function() {
                    self.tableHeight = window.innerHeight - self.$refs.Table.$el.clientTop - 280
                }
                // console.log(window.innerHeight,"H")
            })*/
            this.jsId=this.cost.i_id;
            this.mid=this.cost.i_mid;
            /*if (this.cost.value.i_state_mq==0&&this.cost.value.i_state==1){
                this.disabled=false
            }else if (this.cost.value.i_state_mq==0&&this.cost.value.i_state==3){
                this.disabled=true
            }else if(this.cost.value.i_state_mq==1&&this.cost.value.i_state==1){
                this.disabled=true
            }else{
                this.disabled=true
            }*/
            if (this.cost.value.i_state_mq==0&&this.cost.value.i_state==3){
                this.disabled=true
            }else if(this.cost.value.i_state_mq==0&&this.cost.value.i_state==1){
                this.disabled=false
            }else if(this.cost.value.i_state_mq==1&&this.cost.value.i_state==1){
                this.disabled=true
            }else{
                this.disabled=true
            }

            //this.disabled=(this.cost.value.i_state_mq==0&&this.cost.value.i_state==1)?false:true;
            //console.log(this.disabled,this.cost.value.i_state,this.cost.value.i_state_mq,"0000");
            this.getStatisticsXhList();
        },
        methods: {

            //自定义合计行
            getSummaries(param) {
                const { columns, data } = param;
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = "合计";
                        return;
                    }

                    if (column.property !== undefined) {
                        //加了prop属性的el-table-column 才能找到column.property
                        const values = data.map(item => Number(item[column.property]));
                        if (!values.every(value => isNaN(value))) {
                            sums[index] = values.reduce((prev, curr) => {
                                const value = Number(curr);
                                if (!isNaN(value)) {
                                    return prev + curr; //多行相加
                                } else {
                                    return prev;
                                }
                            }, 0);
                        } else {
                            sums[index] = "";
                        }
                        sums[index] = parseFloat(sums[index]).toFixed(2);
                        //console.log(sums[index],"sums")
                        //sums[index] = parseInt(sums[index]).toFixed(2); //保留2位小数 对字符类型先转数字类型
                    }
                });
                return sums;
            },

            //提交费用列表里单价等
            async sendStatisticsMsg(){
                //console.log(this.tableData,"tableData");
                let param={
                    i_id:this.jsId,
                    i_mid:this.mid,
                };
                let res=await API.sendStatisticsMsg(param);
                if(res.code==1){
                    this.$message.success(res.message);
                    this.disabled=true;
                   // console.log(123);
                    this.$emit('close');
                    this.$emit('getStatisticsList');
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },

            //保存费用列表里单价等
            async saveStatisticsXh(){
                //console.log(this.tableData,this.tablexhData,"tableData");
                let param={
                    i_id:this.jsId,
                    details:this.tableData,
                    details1:this.tablexhData,
                    i_mid:this.mid,
                };
                let res=await API.saveStatisticsXh(param);
                if(res.code==1){
                    //this.disabled=true;
                    this.$message.success(res.message);
                    this.sendStatisticsMsg();
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },

            //获取费用列表
            async getStatisticsXhList(){
                let param = {
                    i_id:this.jsId,
                    i_mid:this.mid,
                };
                let res = await API.getStatisticsXhList(param);
                if (res.code == 1) {
                    this.loading=false;
                    this.tableData=res.data.details;
                    this.tablexhData=res.data.details1;
                    //this.tableTotal=res.count;
                    //console.log(this.tableData,this.tablexhData,"this.tableData");
                    //this.$message.success(res.message);
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },

            //关闭
            cancel() {
                //console.log(this.pageSize,"------")
                this.$emit('close');
            },
        },
    }
</script>

<style lang="scss" scoped>


    .flex{
        justify-content: left;
    }

    .fr{
        float: right;
    }

    .mrt20{
        margin-top: 20px;
    }

    .mrl2{
        margin-left: 2px;
    }

    .mrl15{
        margin-left: 15px;
    }

    .mrt5{
        margin-top: 5px;
    }

    .mrb5{
        margin-bottom: 5px;
    }

    .mrr2{
        margin-right: 8px;
    }



    /deep/{


        .el-table__body-wrapper {
            height: 310px !important;
        }

        .el-dialog__body{
            word-break:unset;

        }
        .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
            color: white;
        }
        .el-date-editor.el-input, .el-date-editor.el-input__inner {
            width: 150px;
        }
        .page {
            padding: 15px;
        }

    }

</style>